import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgRedRejection = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={50}
    height={50}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
      fill="#EF6355"
      fillOpacity={0.17}
    />
    <path
      d="m40.309 21.236-4.473-10.745c-.109-.273-.436-.491-.763-.491H14.509c-.327 0-.6.218-.71.49L9.328 21.237a3.77 3.77 0 0 0 .11 3.164c.381.71.872 1.31 1.581 1.745v11.673c0 1.2 1.091 2.182 2.455 2.182h22.8c1.363 0 2.454-.982 2.454-2.182V26.145A4.874 4.874 0 0 0 40.31 24.4c.382-.982.436-2.127 0-3.164Zm-3.327 16.582c0 .328-.382.546-.819.546H13.418c-.436 0-.818-.273-.818-.546V26.8c.873.164 1.8.11 2.618-.273.818-.327 1.527-.873 2.018-1.636.873 1.2 2.237 1.964 3.764 1.964a4.51 4.51 0 0 0 3.764-1.964c.872 1.2 2.236 1.964 3.763 1.964a4.51 4.51 0 0 0 3.764-1.964c.49.709 1.2 1.255 2.018 1.636a4.77 4.77 0 0 0 2.618.273v11.018h.055Zm1.745-14.182c-.382.819-1.145 1.364-2.018 1.528-.873.163-1.745 0-2.455-.6-.709-.6-1.09-1.364-1.09-2.291a.839.839 0 0 0-.819-.819.839.839 0 0 0-.818.819c-.054 1.036-.6 1.963-1.527 2.454-.873.491-2.018.491-2.891 0-.873-.49-1.473-1.473-1.527-2.454a.839.839 0 0 0-.819-.819.839.839 0 0 0-.818.819c-.054 1.036-.6 1.963-1.527 2.454-.873.491-2.018.491-2.89 0-.873-.49-1.473-1.473-1.528-2.454a.839.839 0 0 0-.818-.819.839.839 0 0 0-.819.819c0 .872-.436 1.745-1.09 2.29a3.06 3.06 0 0 1-2.455.6c-.873-.163-1.582-.763-2.018-1.527-.273-.545-.327-1.2-.055-1.8l4.31-10.2h19.472l4.255 10.2c.272.6.218 1.255-.055 1.8Z"
      fill="#EF6355"
    />
    <path
      d="M27.982 29.036a.791.791 0 0 0-1.146 0L24.873 31l-1.964-1.964a.791.791 0 0 0-1.145 0 .79.79 0 0 0 0 1.146l1.963 1.963-1.963 1.964a.79.79 0 0 0 0 1.146c.163.163.381.218.6.218.218 0 .436-.055.6-.218l1.963-1.964 1.964 1.964c.163.163.382.218.6.218.218 0 .436-.055.6-.218a.79.79 0 0 0 0-1.146l-1.964-1.964 1.964-1.963a.914.914 0 0 0-.11-1.146Z"
      fill="#EF6355"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgRedRejection);
export default ForwardRef;
